import { FuseSplashScreen } from "@fuse";
import _ from "@lodash";
import { withStyles } from "@material-ui/core";
import * as userActions from "app/Core/Funcionalidade/Auth/store/actions";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import FirebaseAuthService from "app/Core/services/FirebaseAuthService";
import * as AppActions from "app/store/actions";
import Constante from "Constante.json";
import history from "history.js";
import React from "react";
import themesConfig from "app/Configs/fuse-configs/themesConfig";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import { bindActionCreators } from "redux";


const styles = theme => ({
    root: {
        background: theme.palette.type === "dark" ? "#424242" : "#E6E6E6",
        color: theme.palette.primary.contrastText
    },
    paper: {
        width: "70%",
    },
    card: {
        background: theme.palette.type === "dark" ? "#494949" : "#FFFFFF",
        color: theme.palette.type === "dark" ? "#FFFFFF" : "#494949",
    },
    version: {
        position: "absolute",
        right: 12,
        bottom: 12,
        cursor: "pointer"
    },
    content: {
        background: theme.palette.type === "dark" ? "#424242" : "#E6E6E6",
        color: theme.palette.type === "dark" ? "#CCC" : "#666",
        border: "1px solid " + theme.palette.divider,
        borderRadius: 10,
    },
    image: {
        display: "flex",
        "@media (max-width: 960px)": {
            display: "none"
        }

    }
});

class Token extends XAPPComponent {

    componentDidMount() {
        const { search } = document.location;
        var AQueryParsed = null;
        if (search) {
            AQueryParsed = queryString.parse(search);
        }
        if (!_.isUndefined(AQueryParsed) && !_.isNull(AQueryParsed)) {
            if (!_.isUndefined(AQueryParsed.id) && !_.isNull(AQueryParsed.id)) {
                sessionStorage.setItem("organizacao", AQueryParsed.id);
            }
            if (!_.isUndefined(AQueryParsed.ctx) && !_.isNull(AQueryParsed.ctx)) {
                sessionStorage.setItem("ctx", AQueryParsed.ctx);
            }
            if (!_.isUndefined(AQueryParsed.sistema) && !_.isNull(AQueryParsed.sistema)) {
                sessionStorage.setItem("sistema", AQueryParsed.sistema);
            }
            if (!_.isUndefined(AQueryParsed.plano) && !_.isNull(AQueryParsed.plano)) {
                sessionStorage.setItem("plano", AQueryParsed.plano);
            }
            if (!_.isUndefined(AQueryParsed.usr) && !_.isNull(AQueryParsed.usr)) {
                sessionStorage.setItem("username", AQueryParsed.usr);
            }
            if (!_.isUndefined(AQueryParsed.login) && !_.isNull(AQueryParsed.login)) {
                sessionStorage.setItem("login", AQueryParsed.login);
            }
            if (!_.isUndefined(AQueryParsed.tk) && !_.isNull(AQueryParsed.tk)) {
                sessionStorage.setItem("google_access_token", AQueryParsed.tk);
            }
            if (!_.isUndefined(AQueryParsed.cap) && !_.isNull(AQueryParsed.cap)) {
                sessionStorage.setItem("recaptcha", AQueryParsed.cap);
            }
        }
        this.ValidarToken();
    }

    ValidarToken = () => {
        const { location } = document;
        var AQueryParsed = null;
        if (location.search) {
            AQueryParsed = queryString.parse(location.search);
        }
        FirebaseAuthService.signInWithToken()
            .then(resp => {
                this.props.setUserData(resp.user, resp.access_token, resp.status_xapp);
                const user = resp.user.data;
                if (user.settings !== null) {
                    sessionStorage.setItem("theme", themesConfig[user.settings.theme.main].palette.primary.main);
                    sessionStorage.setItem("themetype", themesConfig[user.settings.theme.main].palette.type);
                    sessionStorage.setItem("tipo-sistema", user.settings.tipo);
                    sessionStorage.setItem("plano", user.settings.plano);
                    sessionStorage.setItem("jwt_access_token", resp.access_token);
                    this.props.setNavigation(user.settings);

                    if (!_.isNull(user.settings.versao) && user.settings.versao !== Constante.versao && !location.host.includes("local")) {
                        location.href = "https://site.hexapp.com.br/site/atualizar-sistema?old=" + Constante.versao + "&new=" + user.settings.versao + "&url=" + document.location.host;
                    }
                    else if (!_.isNull(user.settings.novoambiente) && user.settings.novoambiente === "0") {
                        const AEmpresa = Object.keys(user.settings.sistemas)[0];
                        history.push(`/atualizando?t=Configurando+novo+ambiente...&m=NovoAmbiente&u=${user.usuario}&e=${AEmpresa}`);
                    }
                    else if (!_.isNull(AQueryParsed) && !_.isUndefined(AQueryParsed.q) && !_.isNull(AQueryParsed.q)) {
                        history.push(AQueryParsed.q);
                    }
                    else {
                        history.push("/home");
                    }
                }
            })
            .catch(error => {
                history.push("/pub-login");
                this.props.showMessage({
                    message: error,
                    variant: "error"
                });
            });
    };

    render() {
        return (
            <React.Fragment>
                <FuseSplashScreen />
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setUserData: userActions.setUserData,
        showMessage: AppActions.showMessage,
        setNavigation: AppActions.setNavigation,
        setOrganizacoes: userActions.setOrganizacoes,
    }, dispatch);
}

function mapStateToProps({ fuse, auth }) {
    return {
        theme: fuse.settings.mainTheme,
        user: auth.user.data,
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Token)));
